import { createContext, useContext } from "react";

/**
 * Provided by <AppShell />. Lets descendant `<Header />` instances
 * detect they're inside the new shell and render nothing, so legacy
 * pages keep working unchanged during the dashboard-redesign rollout.
 */
export const AppShellContext = createContext<{ inShell: boolean }>({
  inShell: false,
});

export function useAppShell() {
  return useContext(AppShellContext);
}
